// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CostCodeSelectQueryVariables = Types.Exact<{
  filter: Types.CostCodeFilter;
}>;


export type CostCodeSelectQuery = { __typename?: 'Query', costCodes: Array<{ __typename?: 'CostCode', id: string, displayName: string }> };

export type CostCodeSelect_CostCodeFragment = { __typename?: 'CostCode', id: string, displayName: string };

export const CostCodeSelect_CostCodeFragmentDoc = gql`
    fragment CostCodeSelect_CostCode on CostCode {
  ...DisplayNamed
}
    ${DisplayNamedFragmentDoc}`;
export const CostCodeSelectDocument = gql`
    query CostCodeSelect($filter: CostCodeFilter!) {
  costCodes(filter: $filter) {
    ...CostCodeSelect_CostCode
  }
}
    ${CostCodeSelect_CostCodeFragmentDoc}`;

/**
 * __useCostCodeSelectQuery__
 *
 * To run a query within a React component, call `useCostCodeSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostCodeSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostCodeSelectQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCostCodeSelectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CostCodeSelectQuery, CostCodeSelectQueryVariables> & ({ variables: CostCodeSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CostCodeSelectQuery, CostCodeSelectQueryVariables>(CostCodeSelectDocument, options);
      }
export function useCostCodeSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CostCodeSelectQuery, CostCodeSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CostCodeSelectQuery, CostCodeSelectQueryVariables>(CostCodeSelectDocument, options);
        }
export function useCostCodeSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CostCodeSelectQuery, CostCodeSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CostCodeSelectQuery, CostCodeSelectQueryVariables>(CostCodeSelectDocument, options);
        }
export type CostCodeSelectQueryHookResult = ReturnType<typeof useCostCodeSelectQuery>;
export type CostCodeSelectLazyQueryHookResult = ReturnType<typeof useCostCodeSelectLazyQuery>;
export type CostCodeSelectSuspenseQueryHookResult = ReturnType<typeof useCostCodeSelectSuspenseQuery>;
export type CostCodeSelectQueryResult = Apollo.QueryResult<CostCodeSelectQuery, CostCodeSelectQueryVariables>;